import React, { useMemo } from 'react'
import HotSwapSummary from '../how-swap-summary'
import { makeStyles } from '@material-ui/core/styles'
import HotSwapDatePicker from '../hot-swap-date-picker'
import HotSwapTimePicker from '../hot-swap-time-picker'
import { useQuery } from 'react-query'
import { getHotswapWeeksAvailabilityByLocationIds } from '../../api/hotswaps-api'

export default function ScheduleServiceStep({
    selectedHotSwapLocations,
    setScheduledDate,
    setScheduledTime
}) {
    const classes = useStyles()

    const onDateChange = value => {
        setScheduledDate(value)
    }

    const onTimeChange = value => {
        setScheduledTime(value)
    }

    const locations = useMemo(() => {
        if (selectedHotSwapLocations) {
            return selectedHotSwapLocations
                .map(location => location.id)
                .join(',')
        }

        return ''
    }, [data])

    const { data } = useQuery([locations], () =>
        getHotswapWeeksAvailabilityByLocationIds(locations)
    )

    return (
        <div className={classes.container}>
            <HotSwapSummary
                selectedHotSwapLocations={selectedHotSwapLocations}
            />
            {data && (
                <HotSwapDatePicker
                    onDateChange={onDateChange}
                    disableWeeks={data}
                />
            )}
            <HotSwapTimePicker onTimeChange={onTimeChange} />
        </div>
    )
}

const useStyles = makeStyles(() => ({
    container: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: '75px'
    }
}))
